import {
  Loading,
  PrimaryButton,
  ProfilePicture,
  SecondaryButton,
} from "../../components";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "../../hooks";
import "./account.scss";

const Account = () => {
  const user = useCurrentUser();
  const nav = useNavigate();

  return (
    <section className="part-page" id="account-section">
      {user.isLoading ? (
        <Loading />
      ) : (
        <>
          <div id="account">
            <ProfilePicture path={user.data?.profilePic} />
            <div id="infos">
              <h2 id="name">
                {user.data?.accountType === "user"
                  ? user.data?.firstname + " " + user.data?.lastname
                  : user.data?.username}
              </h2>
              <h3 id="username">
                {user.data?.accountType === "user"
                  ? user.data?.username
                  : user.data?.email}
              </h3>
              <p id="bio">{user.data?.bio}</p>
            </div>
          </div>
          <div id="actions">
            <h2>
              Salut{" "}
              <span className="highlighted" id="test">
                {user.data?.accountType === "user"
                  ? user.data?.firstname
                  : user.data?.username}
                ,
              </span>
            </h2>
            <h2>Quel bon vent t'amène ?</h2>
            <div id="buttons">
              <PrimaryButton link="/leave-a-print">
                Laisser mon empreinte
              </PrimaryButton>
              <SecondaryButton
                onClick={() => {
                  signOut(auth);
                  nav("/");
                }}
              >
                Déconnexion
              </SecondaryButton>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Account;
